module.exports = __webpack_public_path__ + "static/media/grassWalk.a1486b01.mp3";